import axios from "axios";
import { IAnyObj, Fn, FcResponse } from "./interface";
import {
  handleAuth,
  handleAuthError,
  handleGeneralError,
  handleNetworkError,
  handleRequestHeader,
} from "./tool";
import { message } from 'antd'

const myAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
  },
});

const AuthProvider = () => {
  localStorage.removeItem("come-to-chant-token")
  localStorage.removeItem("userInfoObject")
  localStorage.removeItem("userInfo")
  localStorage.removeItem("user_uid")
}
// 请求拦截器
myAxios.interceptors.request.use((config) => {
  config = handleRequestHeader(config);
  config = handleAuth(config);
  return config;
});

// 响应拦截器
myAxios.interceptors.response.use(
  (response: any) => {

    if (response.status !== 200) return Promise.reject(response.data);

    if (response.data.code === 401) {
      message.error(response.data.error);
      setTimeout(() => {
        AuthProvider()
      }, 1000)
    }

    handleAuthError(response.data.error);
    handleGeneralError(response.data.code, response.data.error);
    return response;
  },
  (err) => {
    console.log(err);
    handleNetworkError(err);
    Promise.reject(err);
  }
);

// GET
export const Get = <T>(
  url: string,
  params: IAnyObj = {},
  otherProps?: any
): Promise<any> =>
  new Promise((resolve) => {
    myAxios
      .get(url, { params, ...otherProps })
      .then((result) => {
        let res: FcResponse<T>;
        res = result.data as FcResponse<T>;
        resolve(res as FcResponse<T>);
      })
      .catch((err) => {
        resolve([err, undefined]);
      });
  });

// POST
export const Post = <T>(
  url: string,
  data?: IAnyObj,
  headers?: any,
  params: IAnyObj = {}
): Promise<any> => {
  return new Promise((resolve) => {
    myAxios
      .post(url, data, { headers,params })
      .then((result) => {
        resolve(result.data as FcResponse<T>);
      })
      .catch((err) => {
        resolve([err, undefined]);
      });
  });
};
 
// PUT
export const Put = <T>(
  url: string,
  headers?: any,
  data?: IAnyObj,
  params: IAnyObj = {}
): Promise<any> => {
  return new Promise((resolve) => {
      myAxios
      .put(url, data, { params })
      .then((result: any) => {
        resolve(result.data as FcResponse<T>);
      })
      .catch((err: any) => {
        resolve([err, undefined]);
      });
  });
};

// DELETE
export const Delete = <T>(
    url: string,
    headers?: any,
    params: IAnyObj = {}
): Promise<any> => {
    return new Promise((resolve) => {
        myAxios
            .delete(url, { headers, params }) // 将headers和params放在一个对象中作为delete方法的第二个参数
            .then((result: any) => {
                resolve(result.data as FcResponse<T>);
            })
            .catch((err: any) => {
                resolve([err, undefined]);
            });
    });
};
